import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateGatewayMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  e164?: Types.InputMaybe<Types.Scalars['String']['input']>;
  shortNumber: Types.Scalars['String']['input'];
  displayName: Types.Scalars['String']['input'];
  sipUser: Types.Scalars['String']['input'];
  sipPassword: Types.Scalars['String']['input'];
  enabled: Types.Scalars['Boolean']['input'];
  callbackNumberId: Types.Scalars['Int']['input'];
}>;


export type CreateGatewayMutation = { __typename?: 'Mutation', createGateway?: { __typename?: 'SaveResult', id?: number | null, errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } | null };

export type GetCallbackDataQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type GetCallbackDataQuery = { __typename?: 'Query', users?: { __typename?: 'UserList', items: Array<{ __typename?: 'User', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, faxes?: { __typename?: 'FaxList', items: Array<{ __typename?: 'Fax', id: number, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, groups?: { __typename?: 'GroupList', items: Array<{ __typename?: 'Group', id: number, name: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, ivrs?: { __typename?: 'IvrList', items: Array<{ __typename?: 'Ivr', name: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null };

export type GatewayLimitQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type GatewayLimitQuery = { __typename?: 'Query', domainAllocation: { __typename?: 'DomainAllocations', services: { __typename?: 'ServiceDomainAllocationsInfo', gateway: { __typename?: 'DomainAllocationInfo', domainAllocated: number, domainUsed: number, remaining: number, allocationIncrementError?: { __typename?: 'Error', type: string, context?: string | null } | null } } } };

export type DeleteGatewayMutationVariables = Types.Exact<{
  gatewayId: Types.Scalars['Int']['input'];
  relatedData: Types.GatewayRetargets;
}>;


export type DeleteGatewayMutation = { __typename?: 'Mutation', deleteGateway?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null } | null> | null };

export type GatewayRelatedDataQueryVariables = Types.Exact<{
  gatewayId: Types.Scalars['Int']['input'];
}>;


export type GatewayRelatedDataQuery = { __typename?: 'Query', relatedData: { __typename?: 'References', overrideCaller: Array<{ __typename?: 'User', id: number, displayName: string, number?: { __typename?: 'Number', shortNumber?: string | null } | null }> } };

export type GetGatewayTargetsQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type GetGatewayTargetsQuery = { __typename?: 'Query', gateways?: { __typename?: 'GatewayList', items: Array<{ __typename?: 'Gateway', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, faxes?: { __typename?: 'FaxList', items: Array<{ __typename?: 'Fax', id: number, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null };

export type GetRandomSipUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetRandomSipUserQuery = { __typename?: 'Query', sipUser?: { __typename?: 'SIPUser', username: string, password: string } | null };

export type GatewayListFragment = { __typename?: 'Gateway', displayName: string, number?: { __typename?: 'Number', e164?: any | null, shortNumber?: string | null } | null };

export const GatewayListFragmentDoc = gql`
    fragment GatewayList on Gateway {
  displayName
  number {
    e164
    shortNumber
  }
}
    `;
export const CreateGatewayDocument = gql`
    mutation CreateGateway($domainId: Int!, $e164: String, $shortNumber: String!, $displayName: String!, $sipUser: String!, $sipPassword: String!, $enabled: Boolean!, $callbackNumberId: Int!) {
  createGateway(
    domainId: $domainId
    e164: $e164
    shortNumber: $shortNumber
    displayName: $displayName
    sipUser: $sipUser
    sipPassword: $sipPassword
    enabled: $enabled
    callbackNumberId: $callbackNumberId
  ) {
    id
    errors {
      location
      context
      type
    }
  }
}
    `;
export type CreateGatewayMutationFn = Apollo.MutationFunction<CreateGatewayMutation, CreateGatewayMutationVariables>;

/**
 * __useCreateGatewayMutation__
 *
 * To run a mutation, you first call `useCreateGatewayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGatewayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGatewayMutation, { data, loading, error }] = useCreateGatewayMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      e164: // value for 'e164'
 *      shortNumber: // value for 'shortNumber'
 *      displayName: // value for 'displayName'
 *      sipUser: // value for 'sipUser'
 *      sipPassword: // value for 'sipPassword'
 *      enabled: // value for 'enabled'
 *      callbackNumberId: // value for 'callbackNumberId'
 *   },
 * });
 */
export function useCreateGatewayMutation(baseOptions?: Apollo.MutationHookOptions<CreateGatewayMutation, CreateGatewayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGatewayMutation, CreateGatewayMutationVariables>(CreateGatewayDocument, options);
      }
export type CreateGatewayMutationHookResult = ReturnType<typeof useCreateGatewayMutation>;
export type CreateGatewayMutationResult = Apollo.MutationResult<CreateGatewayMutation>;
export type CreateGatewayMutationOptions = Apollo.BaseMutationOptions<CreateGatewayMutation, CreateGatewayMutationVariables>;
export const GetCallbackDataDocument = gql`
    query GetCallbackData($domainId: Int!) {
  users(domainId: $domainId) {
    items {
      id
      number {
        id
        shortNumber
      }
      displayName
    }
  }
  faxes(domainId: $domainId) {
    items {
      id
      number {
        id
        shortNumber
      }
    }
  }
  groups(domainId: $domainId) {
    items {
      id
      name
      number {
        id
        shortNumber
      }
    }
  }
  ivrs(domainId: $domainId) {
    items {
      name
      number {
        id
        shortNumber
      }
    }
  }
}
    `;

/**
 * __useGetCallbackDataQuery__
 *
 * To run a query within a React component, call `useGetCallbackDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallbackDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallbackDataQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useGetCallbackDataQuery(baseOptions: Apollo.QueryHookOptions<GetCallbackDataQuery, GetCallbackDataQueryVariables> & ({ variables: GetCallbackDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCallbackDataQuery, GetCallbackDataQueryVariables>(GetCallbackDataDocument, options);
      }
export function useGetCallbackDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCallbackDataQuery, GetCallbackDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCallbackDataQuery, GetCallbackDataQueryVariables>(GetCallbackDataDocument, options);
        }
export function useGetCallbackDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCallbackDataQuery, GetCallbackDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCallbackDataQuery, GetCallbackDataQueryVariables>(GetCallbackDataDocument, options);
        }
export type GetCallbackDataQueryHookResult = ReturnType<typeof useGetCallbackDataQuery>;
export type GetCallbackDataLazyQueryHookResult = ReturnType<typeof useGetCallbackDataLazyQuery>;
export type GetCallbackDataSuspenseQueryHookResult = ReturnType<typeof useGetCallbackDataSuspenseQuery>;
export type GetCallbackDataQueryResult = Apollo.QueryResult<GetCallbackDataQuery, GetCallbackDataQueryVariables>;
export const GatewayLimitDocument = gql`
    query GatewayLimit($domainId: Int!) {
  domainAllocation(domainId: $domainId) {
    services {
      gateway {
        domainAllocated
        domainUsed
        remaining
        allocationIncrementError {
          type
          context
        }
      }
    }
  }
}
    `;

/**
 * __useGatewayLimitQuery__
 *
 * To run a query within a React component, call `useGatewayLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGatewayLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGatewayLimitQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useGatewayLimitQuery(baseOptions: Apollo.QueryHookOptions<GatewayLimitQuery, GatewayLimitQueryVariables> & ({ variables: GatewayLimitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GatewayLimitQuery, GatewayLimitQueryVariables>(GatewayLimitDocument, options);
      }
export function useGatewayLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GatewayLimitQuery, GatewayLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GatewayLimitQuery, GatewayLimitQueryVariables>(GatewayLimitDocument, options);
        }
export function useGatewayLimitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GatewayLimitQuery, GatewayLimitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GatewayLimitQuery, GatewayLimitQueryVariables>(GatewayLimitDocument, options);
        }
export type GatewayLimitQueryHookResult = ReturnType<typeof useGatewayLimitQuery>;
export type GatewayLimitLazyQueryHookResult = ReturnType<typeof useGatewayLimitLazyQuery>;
export type GatewayLimitSuspenseQueryHookResult = ReturnType<typeof useGatewayLimitSuspenseQuery>;
export type GatewayLimitQueryResult = Apollo.QueryResult<GatewayLimitQuery, GatewayLimitQueryVariables>;
export const DeleteGatewayDocument = gql`
    mutation DeleteGateway($gatewayId: Int!, $relatedData: GatewayRetargets!) {
  deleteGateway(gatewayId: $gatewayId, relatedData: $relatedData) {
    location
    type
    context
  }
}
    `;
export type DeleteGatewayMutationFn = Apollo.MutationFunction<DeleteGatewayMutation, DeleteGatewayMutationVariables>;

/**
 * __useDeleteGatewayMutation__
 *
 * To run a mutation, you first call `useDeleteGatewayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGatewayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGatewayMutation, { data, loading, error }] = useDeleteGatewayMutation({
 *   variables: {
 *      gatewayId: // value for 'gatewayId'
 *      relatedData: // value for 'relatedData'
 *   },
 * });
 */
export function useDeleteGatewayMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGatewayMutation, DeleteGatewayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGatewayMutation, DeleteGatewayMutationVariables>(DeleteGatewayDocument, options);
      }
export type DeleteGatewayMutationHookResult = ReturnType<typeof useDeleteGatewayMutation>;
export type DeleteGatewayMutationResult = Apollo.MutationResult<DeleteGatewayMutation>;
export type DeleteGatewayMutationOptions = Apollo.BaseMutationOptions<DeleteGatewayMutation, DeleteGatewayMutationVariables>;
export const GatewayRelatedDataDocument = gql`
    query GatewayRelatedData($gatewayId: Int!) {
  relatedData(id: $gatewayId, numberType: GATEWAY) {
    overrideCaller {
      id
      displayName
      number {
        shortNumber
      }
    }
  }
}
    `;

/**
 * __useGatewayRelatedDataQuery__
 *
 * To run a query within a React component, call `useGatewayRelatedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGatewayRelatedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGatewayRelatedDataQuery({
 *   variables: {
 *      gatewayId: // value for 'gatewayId'
 *   },
 * });
 */
export function useGatewayRelatedDataQuery(baseOptions: Apollo.QueryHookOptions<GatewayRelatedDataQuery, GatewayRelatedDataQueryVariables> & ({ variables: GatewayRelatedDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GatewayRelatedDataQuery, GatewayRelatedDataQueryVariables>(GatewayRelatedDataDocument, options);
      }
export function useGatewayRelatedDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GatewayRelatedDataQuery, GatewayRelatedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GatewayRelatedDataQuery, GatewayRelatedDataQueryVariables>(GatewayRelatedDataDocument, options);
        }
export function useGatewayRelatedDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GatewayRelatedDataQuery, GatewayRelatedDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GatewayRelatedDataQuery, GatewayRelatedDataQueryVariables>(GatewayRelatedDataDocument, options);
        }
export type GatewayRelatedDataQueryHookResult = ReturnType<typeof useGatewayRelatedDataQuery>;
export type GatewayRelatedDataLazyQueryHookResult = ReturnType<typeof useGatewayRelatedDataLazyQuery>;
export type GatewayRelatedDataSuspenseQueryHookResult = ReturnType<typeof useGatewayRelatedDataSuspenseQuery>;
export type GatewayRelatedDataQueryResult = Apollo.QueryResult<GatewayRelatedDataQuery, GatewayRelatedDataQueryVariables>;
export const GetGatewayTargetsDocument = gql`
    query GetGatewayTargets($domainId: Int!) {
  gateways(domainId: $domainId) {
    items {
      id
      displayName
      number {
        id
        shortNumber
      }
    }
  }
  faxes(domainId: $domainId) {
    items {
      id
      number {
        id
        shortNumber
      }
    }
  }
}
    `;

/**
 * __useGetGatewayTargetsQuery__
 *
 * To run a query within a React component, call `useGetGatewayTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGatewayTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGatewayTargetsQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useGetGatewayTargetsQuery(baseOptions: Apollo.QueryHookOptions<GetGatewayTargetsQuery, GetGatewayTargetsQueryVariables> & ({ variables: GetGatewayTargetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGatewayTargetsQuery, GetGatewayTargetsQueryVariables>(GetGatewayTargetsDocument, options);
      }
export function useGetGatewayTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGatewayTargetsQuery, GetGatewayTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGatewayTargetsQuery, GetGatewayTargetsQueryVariables>(GetGatewayTargetsDocument, options);
        }
export function useGetGatewayTargetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGatewayTargetsQuery, GetGatewayTargetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGatewayTargetsQuery, GetGatewayTargetsQueryVariables>(GetGatewayTargetsDocument, options);
        }
export type GetGatewayTargetsQueryHookResult = ReturnType<typeof useGetGatewayTargetsQuery>;
export type GetGatewayTargetsLazyQueryHookResult = ReturnType<typeof useGetGatewayTargetsLazyQuery>;
export type GetGatewayTargetsSuspenseQueryHookResult = ReturnType<typeof useGetGatewayTargetsSuspenseQuery>;
export type GetGatewayTargetsQueryResult = Apollo.QueryResult<GetGatewayTargetsQuery, GetGatewayTargetsQueryVariables>;
export const GetRandomSipUserDocument = gql`
    query GetRandomSipUser {
  sipUser {
    username
    password
  }
}
    `;

/**
 * __useGetRandomSipUserQuery__
 *
 * To run a query within a React component, call `useGetRandomSipUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRandomSipUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRandomSipUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRandomSipUserQuery(baseOptions?: Apollo.QueryHookOptions<GetRandomSipUserQuery, GetRandomSipUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRandomSipUserQuery, GetRandomSipUserQueryVariables>(GetRandomSipUserDocument, options);
      }
export function useGetRandomSipUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRandomSipUserQuery, GetRandomSipUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRandomSipUserQuery, GetRandomSipUserQueryVariables>(GetRandomSipUserDocument, options);
        }
export function useGetRandomSipUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRandomSipUserQuery, GetRandomSipUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRandomSipUserQuery, GetRandomSipUserQueryVariables>(GetRandomSipUserDocument, options);
        }
export type GetRandomSipUserQueryHookResult = ReturnType<typeof useGetRandomSipUserQuery>;
export type GetRandomSipUserLazyQueryHookResult = ReturnType<typeof useGetRandomSipUserLazyQuery>;
export type GetRandomSipUserSuspenseQueryHookResult = ReturnType<typeof useGetRandomSipUserSuspenseQuery>;
export type GetRandomSipUserQueryResult = Apollo.QueryResult<GetRandomSipUserQuery, GetRandomSipUserQueryVariables>;